<template>
  <div
    class="d-flex-column justify-start booster_dashboard_banner align-start gap-30"
    :class="[boosterRank.toLowerCase()]"
  >
    <div class="d-flex-row justify-start gap-24">
      <div class="booster_avatar_container">
        <img
          :src="handleAvatar(avatar, publicConfig.apiBaseUrl)"
          alt="Booster avatar"
          class="booster_avatar"
        />

        <div v-if="online == 1" class="online-indicator-online"></div>
        <svg
          v-else
          class="online-indicator"
          width="20"
          height="20"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="1.5" y="1.5" width="12" height="12" rx="6" fill="#fc485a" />
          <rect
            x="1.5"
            y="1.5"
            width="12"
            height="12"
            rx="6"
            stroke="#0E1012"
            stroke-width="3"
          />
        </svg>
      </div>

      <div class="d-flex-column justify-start align-start">
        <div class="d-flex-row space-between">
          <h4 class="title-h4 t-white font-family-1">
            {{ username }}
          </h4>
          <TopBoosterBadge v-if="boosterRank === 'Top Rated'" />
          <TopBoosterBadge v-else-if="boosterRank === 'Top Rated Plus'" />
          <TopBoosterBadge v-else-if="boosterRank.includes('Top Rated')" />

          <ExpertBoosterBadge v-if="boosterRank.includes('Expert')" />
        </div>
        <div class="d-flex-row justify-start gap-10">
          <div class="booster_rating gap-5">
            <star-icon />
            <h4 class="t-white bold-s f-w-600 font-family-1">
              <!-- {{ getUser.reviews_score }} -->
              {{ reviewsScore }}
            </h4>
          </div>
          <div class="booster_rating gap-5">
            <message-icon />
            <h4 class="t-white bold-s f-w-600 font-family-1">
              <!-- {{ getUser.reviews_count }} -->
              {{ reviewsCount }}
            </h4>
          </div>
          <div class="booster_rating gap-5">
            <h4 class="t-green regular-s font-family-1 f-w-600">
              {{ $t("common.available_for_order") }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex-column justify-start align-start gap-12">
      <h4 class="t-white font-family-2">{{ $t("common.about") }}</h4>
      <p class="regular-l t-light font-family-2" style="white-space: pre-wrap">
        {{ bio }}
      </p>
    </div>
    <div
      class="d-flex-column justify-start align-start gap-12"
      v-if="languages.length > 0"
    >
      <h4 class="t-white font-family-2">
        {{ $t("common.languages") }}
      </h4>
      <p class="regular-l t-light font-family-2">
        {{ parsedLangauges }}
      </p>
    </div>

    <hr class="horizontal" />

    <div class="d-flex-row space-between md-row-to-col">
      <div class="d-flex-row justify-start flex-5">
        <img
          v-for="platform in platforms"
          :src="platform.image_dark"
          alt="Platform image"
          class="profile_platform_image"
          height="26"
          width="26"
        />
      </div>
      <div class="d-flex-row justify-end">
        <!-- <button
                    class="t-white primary outlined-color large height-42 b-radius-6 medium-m f-w-600 font-family-1"
                >
                    {{ $t("booster_profile.send_tip") }}
                </button> -->
        <button
          class="t-white primary outlined-color large height-42 b-radius-6 medium-m f-w-600 font-family-1"
          @click="buyCoaching"
          role="a"
        >
          {{ $t("booster_profile.buy_coaching") }}
        </button>
        <button
          class="t-white primary filled large height-42 b-radius-6 medium-m f-w-600 font-family-1"
          @click="buyBoosting"
          role="a"
        >
          {{ $t("booster_profile.request_boost") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import StarIcon from "../icons/StarIcon.vue";
import MessageIcon from "../icons/MessageIcon.vue";
import TopBoosterBadge from "../icons/TopBoosterBadge.vue";
import ExpertBoosterBadge from "../icons/ExpertBoosterBadge.vue";
import { games } from "~/configurations/games.config";
export default {
  data() {
    return {
      online: 0,
      games: games,
    };
  },
  computed: {
    parsedLangauges() {
      if (this.languages.length > 0) {
        let langs = this.languages.map((lang) =>
          getLanguageOfCountry(lang.title)
        );
        return langs.join(", ");
      }
      return "";
    },
  },
  components: {
    StarIcon,
    MessageIcon,
    TopBoosterBadge,
    ExpertBoosterBadge,
  },
  props: {
    username: {
      default: "",
    },
    avatar: {
      default: "",
    },
    bio: {
      default: "",
    },
    languages: {
      default: [],
    },
    reviewsScore: {
      default: 0.0,
    },
    reviewsCount: {
      default: 0,
    },
    platforms: {
      default: [],
    },
    boosterRank: {
      default: "",
    },
    onlineStatus: {
      default: 0,
    },
    id: {
      default: null,
    },
    firstGame: {
      default: null,
    },
  },
  methods: {
    async boosterStatus(booster_id) {
      if (booster_id) {
        window.Echo.private("user-status." + booster_id).listen(
          ".user.status.changed",
          (e) => {
            this.online = e.data.online;
          }
        );
      }
    },
    buyCoaching() {
      if (this.firstGame) {
        this.checkoutStore.setBooster(this.id);
        const path = `/${this.firstGame.slug}/e-learning?booster-id=${this.id}`;
        this.$router.push(this.localePath(path));
      }
    },
    buyBoosting() {
      if (this.firstGame) {
        const game = this.games.find(
          (game) => game.slug === this.firstGame.slug
        );
        const tab = game.tabs[1];
        this.$router.push(this.localePath(`${tab.path}?booster-id=${this.id}`));
      }
    },
  },
  beforeUnmount() {
    if (this.id) {
      window.Echo.leave("user-status." + this.id);
    }
  },
  watch: {},
  beforeMount() {
    this.online = this.onlineStatus;
    this.boosterStatus(this.id);
  },
  setup() {
    const { getUser } = useUserStore();
    const checkoutStore = useCheckoutStore();
    const localePath = useLocalePath();
    const { public: publicConfig } = useRuntimeConfig();

    return {
      getUser,
      checkoutStore,
      localePath,
      publicConfig,
    };
  },
};
</script>
